import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import { TLabelProps } from "@/ui/components/form/Label";
import { TextControl } from "../../typography/TextControl";
import { TextBody } from "../../typography/TextBody";

export const Label: FC<TLabelProps> = (
  {
    className,
    children,
    asChild,
    ...props
  },
) => {

  if (asChild) {
    return <TextBody
      {...props}
      tag="span"
      size={2}
      data-component="Label"
      className={cn(
        "text-foreground-muted-strong",
        className,
      )}
      isResponsive={false}
    >
      { children }
    </TextBody>;
  }

  return (
    <TextControl
      {...props}
      tag="span"
      size={2}
      data-component="Label"
      className={cn(
        className,
      )}
      isResponsive={false}
    >
      { children }
    </TextControl>
  );
};

Label.displayName = "Label";
